<template>
  <div
    class="modal fade"
    id="ModalSelectYear"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">انتخاب سال جاری</p>
        </div>

        <!--Body-->
        <div class="modal-body">
          <!-- آیکون تقویم -->
          <i class="far fa-calendar-check fa-4x animated rotateIn mb-4"></i>
          <!-- توضیح روش انتخاب سال -->
          <p class="h7">
            سال مورد نظر را در حالت انتخاب قرار داده و سپس بر روی دکمه تغییر سال
            کلیک نمایید .
          </p>
          <template v-for="year in YearList">
            <!-- لیست سال های دارای اطلاعات -->
            <div
              v-bind:key="year"
              class="
                custom-control custom-radio custom-control-inline
                justify-content-center
                align-items-center
                rounded-pill
                bg-light
                shadow
              "
              style="min-width: 70px; min-height: 30px; max-width: 70px; cursor: pointer; margin-bottom: 12px;"
            >
              <input
                type="radio"
                class="custom-control-input"
                style="cursor: pointer"
                v-bind:id="'input' + year"
                name="inputSelectYear"
                v-bind:checked="year == YearInput"
                v-bind:value="year"
              />
              <!-- اتصال مودل به رادیو اینپوت در عملکرد چکید اختلال ایجاد می کرد -->
              <!-- v-model.number="YearSelect"
                  v-bind:value="year" -->
              <label
                class="custom-control-label pt-1 h6"
                style="cursor: pointer"
                v-bind:for="'input' + year"
                >{{ year }}</label
              >
            </div>
          </template>
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center">
          <a
            class="btn btn-info waves-effect waves-light"
            v-on:click="SelectYear()"
            >تغییر سال</a
          >
          <a
            class="btn btn-outline-info waves-effect waves-light"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      YearList: [1400, 1399, 1398, 1397],
      YearSelect: 0,
    };
  },
  props: ["YearInput"],
  mounted() {
    // بررسی انصراف از نمایش مودال
    // $("#ModalSelectYear").on("hidden.bs.modal", this.SelectYear);
  },
  created() {
    this.getListYearData();
  },
  methods: {
    // دریافت لیست سال های دارای اطلاعات
    getListYearData() {
      this.YearList = this.$store.getters.getListYearData;
    },

    // دریافت لیست سال انتخابی و ارسال به والد
    SelectYear() {
      $("#ModalSelectYear").modal("hide");
      this.YearSelect = $("input[name='inputSelectYear']:checked").val();
      // ارسال مقادریر سال انتخابی به والد
      this.$emit("SetYearFromModal", this.YearSelect);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/RightMenu/Components/SelectYearActive.vue